import { ExportData, FormList, HeaderTitle, Thumbnails } from '@/components';
import { getOfferRecord } from '@/api';
import { Col, InputNumber, Input, message, Modal, Row, Select, Spin, Table, Card, Divider } from 'antd';
import { calcPrice, toDateTime } from '@/utils/utils';
import React, { useEffect, useState } from 'react';
import { useTable } from '@/hooks';
import styles from '@/components/CardItem/index.module.scss';
import { st_spu, st_user } from '@/utils/statetype';

const { statusObj, typeObj, kindObj } = st_spu;
const { statusObj: statusObjs } = st_user;

function FinanceBill({ spu = {} }) {
  console.log("spu", spu)
  const [query, setQuery] = useState({ spuId: spu?.id || 0 });

  useEffect(() => {
    if (spu?.id) {
      setQuery({ ...query, ...{ spuId: spu?.id } });
      flagFn(true);
    }

  }, [spu]);




  const columns = [
    {
      title: '记录编号',
      dataIndex: 'id',
    },
    {
      title: '用户编号',
      dataIndex: 'User',
      render: (e = {}) => e?.id,
    },
    {
      title: '用户头像',
      dataIndex: 'User',
      render: (e = {}) => <Thumbnails images={[e?.avatarUrl]} center />,
    },
    {
      title: '用户名称',
      dataIndex: 'User',
      render: (e = {}) => e?.nickname,
    },
    {
      title: '用户类型',
      dataIndex: 'User',
      render: e => (e?.isRobot === 1 ? '机器人' : '真实用户'),
    },
    {
      title: '商品编号',
      dataIndex: 'Spu',
      render: (e = {}) => e.id,
    },
    {
      title: '商品名称',
      dataIndex: 'Spu',
      render: (e = {}) => e.name,
    },
    {
      title: '商品类别',
      dataIndex: 'Spu',
      render: (e = {}) => kindObj[e.kind],
    },
    {
      title: 'sku编号',
      dataIndex: 'Sku',
      render: (e = {}) => e.id,
    },
    {
      title: 'sku类型',
      dataIndex: 'Sku',
      render: (e = {}) => typeObj[e.type],
    },
    {
      title: '出价价格',
      dataIndex: 'offer',
      render: e => calcPrice(e),
    },
    {
      title: '出价状态',
      dataIndex: 'status',
      render: e => statusObjs[e],
    },
    {
      title: '出价时间',
      dataIndex: 'createdAt',
      render: e => toDateTime(e),
    },
  ]

  useEffect(() => {
    if (spu?.id) {
      setQuery({ ...query, ...{ spuId: spu?.id } });
    }
  }, [spu]);

  const { tableProps, flagFn } = useTable({
    columns,
    isInit: false,
    API: getOfferRecord,
    params: {
      query: query,
    },
  });
  let skuOb = spu?.Skus?.reduce((acc, sku) => {
    acc[sku.id] = sku.id;
    return acc;
  }, {});
  const formData = [
    {
      id: 'skuId',
      label: 'skuId',
      type: 'select',
      selects: skuOb,
      // hideItem: query.type != 1,
      // options: {
      //   mode: 'multiple',
      //   maxTagCount: 1,
      // },
    },
  ];

  const changeQuery = (value = {}, param) => {
    if (!spu?.id) return
    console.log("changeQuery", value, param)
    const { skuId } = value;
    const q = {
      spuId: spu?.id,
      skuId: skuId,
    };

    setQuery({ ...query, ...q });
    flagFn(true);
  };

  return (
    <>
      <Card.Grid className={styles.cardInfo}>
        <Card.Grid className={styles.cardInfo}>
          <Divider type="vertical" className={styles.cardDivider} />
          竞拍记录
        </Card.Grid>
        {/* <Card.Grid className={styles.cardTable}> */}
        <FormList
          formData={formData}
          changeQuery={changeQuery}
          extraRender={
            <ExportData
              API={getOfferRecord}
              title="竞拍记录"
              query={query}
              extend={{
                amount: 'amount',
                createdAt: 'time',
                // kind: kindObj,
              }}
              columns={{
                id: '记录编号',
                'User.id': '用户编号',
                'User.avatarUrl': '用户头像',
                'User.nickname': '用户名称',
                'User.isRobot': '用户类型',
                'Spu.id': '商品编号',
                'Spu.name': '商品名称',
                'Spu.kind': '商品类别',
                'Sku.id': 'sku编号',
                'Sku.type': 'sku类型',
                offer: '出价价格',
                status: '出价状态',
                createdAt: '出价时间',
              }}
            />
          }
        />
        {/* </Card.Grid> */}
        {/* <Card.Grid className={styles.cardTable}> */}
        <Table {...tableProps} />
        {/* </Card.Grid> */}
      </Card.Grid>
    </>

  );
}

export default FinanceBill;
